import { formatDateBasedOnTimezone } from "../../utils/date.utils";
import { getValue } from "../../utils/object.utils";

export const transformBranchListTableData = (branchList: Array<any>): any[] => {
  const transformDatForTable = branchList.map((branch: any): any => {
    return {
      id: branch.id,
      name: branch?.name,
      address: branch?.address,
      establisedDate: formatDateBasedOnTimezone({
        date: getValue(branch, "established_in"),
      }),
      // establisedDate: getValue(branch, "established_in"),
      description: branch?.description,
    };
  });

  return transformDatForTable;
};
